<template>
  <div>
    <div class="header-space"></div>
    <div class="header-plan-area">
      <div class="pointer" v-if="activate <= 9">
        <a
          v-if="!hasUpdateParam"
          class="side-menu-plan-status trial"
          href="https://share.hsforms.com/1XxQIdXE-TXuUbflmQrreVg3fql7"
          target="_blank"
        >今すぐアップグレード</a>
        <router-link v-else class="side-menu-plan-status trial" :to="upgradeLink">今すぐアップグレード</router-link>
      </div>       
      <div class="side-menu-plan-status free" v-if="activate == 20 && admin_mode" style="margin-right:10px">管理者モード</div>            
      <div class="side-menu-plan-status free" @click="activate == 20 ? adminMode() : ''">{{ service_plan_name_en }}</div>
    </div>
    <el-dropdown trigger="click">
      <div class="header-menu-area pointer">
        <div class="header-icon-area">
          <el-image :src="img_url" class="header-logo">
            <div slot="error" class="data-table-list-noimg">
              <font-awesome-icon :icon="['fas', 'building']" />
            </div>
          </el-image>
          <div class="header-client-name">{{ client_name }}</div>
        </div>
        <div class="header-profile">
          <div class="el-dropdown-link" style="font-size:12px">
            <font-awesome-icon :icon="['fas', 'caret-down']" />
            <el-dropdown-menu slot="dropdown">
              <div class="header-client-info">
                <el-image :src="img_url" class="header-logo dropdown">
                  <div slot="error" class="data-table-list-noimg">
                    <font-awesome-icon :icon="['fas', 'building']" />
                  </div>
                </el-image>
                <div class="header-client-info-dropdown">
                  <div class="header-client-info-name">{{ client_name }}</div>
                  <div class="header-client-info-personname">
                    {{ person_name }}
                    <span class="header-client-info-admin" v-show="member_info.admin_member">管理者</span>
                  </div>
                  <div class="header-client-info-personname" style="color:#aaa; font-size:11px">{{ email_private }}</div>
                </div>
              </div>
              <div @click="routerPush('setting', 'plan')">
                <el-dropdown-item divided></el-dropdown-item>
                <el-dropdown-item>
                  <div class="header-dropdown-plan-wrap">
                    ご利用プラン
                    <div class="flex-space"></div>
                    <div class="header-dropdown-plan">{{ service_plan_name_en }}</div>
                  </div>
                </el-dropdown-item>
              </div>
              <div @click="routerPush('setting', 'company_info')">
                <el-dropdown-item>会社情報</el-dropdown-item>
              </div>
              <div @click="routerPush('setting', 'member')" v-if="activate >= 15 || activate == 11">
                <el-dropdown-item>メンバー管理</el-dropdown-item>
              </div>
              <div @click="routerPush('accountSetting', 'mail_pass')">
                <el-dropdown-item>メールアドレス・パスワード設定</el-dropdown-item>
              </div>
              <el-dropdown-item divided @click.native="displayMode()">
                <span v-show="dark_mode"> <font-awesome-icon :icon="['far', 'eclipse-alt']" style="margin-right:5px" />ライトモードに切り替え </span>
                <span v-show="!dark_mode"> <font-awesome-icon :icon="['fas', 'moon']" style="margin-right:5px" />ダークモードに切り替え </span>
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="signOut">ログアウト</el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </div>
      </div>
    </el-dropdown>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
const root = process.env.VUE_APP_API;
const logoutAPI = root + "/api/auth/logout";

export default {
  name: "header",
  data() {
    return {
      activate_change: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    client_name() {
      return this.$store.state.client_name;
    },
    person_name() {
      return this.$store.state.person_name;
    },
    email_private() {
      return this.$store.state.email_private;
    },
    member_info() {
      return this.$store.state.member_info;
    },
    img_url() {
      return this.$store.state.img_url;
    },
    activate() {
      return this.$store.state.activate;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    service_plan_name_en() {      
      return String(this.$store.state.service_plan.service_plan_name_en).toUpperCase();
    },
    // header_notification() {
    //   return this.$store.state.header_notification;
    // },
    trial_expiration_at() {
      return this.$store.state.trial_expiration_at;
    },
    hasUpdateParam() {
      return this.$route.query.update === "6UgWG7ejgXPaL4rF";
    },
    upgradeLink() {
      return "/setting/upgrade";
    },
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.axios
            .get(logoutAPI, {
              params: {
                token: this.token,
                user_token: this.user_token,
              },
            })
            .then(() => {
              this.$store.dispatch("reset");
              this.$router.push("/login");
            });
        });
    },
    displayMode() {
      this.$store.dispatch("displayMode");
    },
    routerPush(name, query) {
      this.$router.push({
        name: name,
        query: {
          activeName: query,
        },
      });
    },
    adminMode() {
      this.$store.dispatch("adminMode");
    },
    changeActivate(value) {
      this.$store.dispatch("changeActivate", value);
    },
    collapse() {
      this.$emit("collapse");
    },
  },
  watch: {
    client_name() {
      this.$forceUpdate();
    },
  },
  filters: {
    expiration(val) {
      const now = new Date();
      const expiration = new Date(val);
      const diffSec = expiration.getTime() - now.getTime();
      const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24) + 1) + "日";
      if (diffSec < 0) {
        return "0日";
      } else {
        return diffDay;
      }
    },
  },
};
</script>
